import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { HiOutlineBan } from "react-icons/hi";
import { REQUEST_ACCEPTED, REQUEST_REJECTED } from "../../../store/string";
//outsource
import { Table, Row, Button, Tooltip, message } from "antd";
import moment from "moment";
//redux
import { useDispatch } from "react-redux";
import { updateRequest } from "../../../store/request/request.action";

const RequestTable = ({ data }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleUpdate = ({ record, status }) => {
    const update = {
      ...record,
      status: status,
      read: false,
    };

    dispatch(
      updateRequest({ update }, (res) => {
        if (res.status === 500) {
          message.error(res.data);
        }
      })
    );
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const columns = [
    {
      key: "createAt",
      title: "Created At",
      dataIndex: "createAt",
      render: (value) => getTime(value, "ddd DD/MM/YYYY hh:mm:ss A"),
    },
    {
      key: "onDate",
      title: "Request On",
      dataIndex: "onDate",
      render: (value) => getTime(value, "ddd DD/MM/YYYY"),
    },
    {
      key: "fullName",
      title: "Full Name",
      dataIndex: "fullName",
    },
    {
      key: "type",
      title: "Type",
      dataIndex: "type",
    },
    {
      key: "note",
      title: "Note",
      dataIndex: "note",
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      align: "center",
      width: 100,
      render: (value, _record) => getStatus(value, _record),
    },
  ];

  const getStatus = (value, record) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Tooltip title="Accept this request">
          <Button
            type="text"
            style={{ color: value === REQUEST_ACCEPTED ? "green" : "#DFDFDF" }}
            onClick={() => handleUpdate({ record, status: REQUEST_ACCEPTED })}
            icon={
              <span className="anticon">
                <AiOutlineCheckCircle size={20} />
              </span>
            }
          />
        </Tooltip>
        <Tooltip placement="left" title="Reject this request">
          <Button
            type="text"
            style={{ color: value === REQUEST_REJECTED ? "red" : "#DFDFDF" }}
            onClick={() => handleUpdate({ record, status: REQUEST_REJECTED })}
            icon={
              <span className="anticon">
                <HiOutlineBan size={20} />
              </span>
            }
          />
        </Tooltip>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return <Table className = 'table-request' columns={columns} bordered dataSource={data} />;
};

export default RequestTable;

const getTime = (value, format) => {
  return moment(value?.toDate()).format(format);
};
